import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Chip,
    TablePagination
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from '@material-ui/icons/Visibility';
import GetAppIcon from '@material-ui/icons/GetApp';
import PrintIcon from '@material-ui/icons/Print';
import HistoryIcon from '@material-ui/icons/History';
import ContractService from '../../services/ContractService';
import AddIcon from '@mui/icons-material/Add';

const useStyles = makeStyles((theme) => ({
    historyButton: {
        marginLeft: theme.spacing(1)
    },
    actionChip: {
        margin: theme.spacing(0.5)
    }
}));

export default function ConsultationHistory({ stagiaireId, open, onClose }) {
    const classes = useStyles();
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);

    // pagination states
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    useEffect(() => {
        if (open && stagiaireId) {
            loadHistory();
        }
    }, [open, stagiaireId]);

    const loadHistory = async () => {
        setLoading(true);
        try {
            ContractService.gethistory(stagiaireId).then((result) => {
                if (result && result.status) {
                    setHistory(result.data);
                }
            });
        } catch (err) {
            console.error('Erreur:', err);
        } finally {
            setLoading(false);
        }
    };

    const getActionIcon = (action) => {
        switch(action) {
            case 'view': return <VisibilityIcon fontSize="small" />;
            case 'download': return <GetAppIcon fontSize="small" />;
            case 'print': return <PrintIcon fontSize="small" />;
            case 'generate': return <AddIcon fontSize="small" />;
            default: return null;
        }
    };

    const getDocumentLabel = (type) => {
        const labels = {
            contrat: 'Contrat',
            assurance: 'Assurance',
            diplome: 'Diplôme',
            attestation:"Attestation de stage"
        };
        return labels[type] || type;
    };

    // pagination handlers
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <HistoryIcon style={{ marginRight: 8 }} />
                Historique des consultations
                <Typography variant="subtitle2" color="textSecondary">
                    Toutes les actions effectuées sur les documents
                </Typography>
            </DialogTitle>

            <DialogContent>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell>Date</TableCell>
                                <TableCell>Document</TableCell>
                                <TableCell>Nom de visiteur</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {history.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">
                                        <Typography variant="body2" color="textSecondary">
                                            Aucun historique trouvé
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                history
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item) => (
                                        <TableRow key={item.id}>
                                            <TableCell>
                                                {new Date(item.created_at).toLocaleString('fr-FR')}
                                            </TableCell>
                                            <TableCell>
                                                {getDocumentLabel(item.document_type)}
                                            </TableCell>
                                            <TableCell>
                                                {item.nom}
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    icon={getActionIcon(item.action)}
                                                    label={
                                                        item.action === 'view'
                                                            ? 'Visualisation'
                                                            : item.action === 'download'
                                                            ? 'Téléchargement'
                                                            : item.action === 'print'? 'Impression'
                                                            :"Création attestation de stage"
                                                    }
                                                    size="small"
                                                    variant="outlined"
                                                    className={classes.actionChip}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                            )}
                        </TableBody>
                    </Table>

                    {/* Pagination */}
                    <TablePagination
                        component="div"
                        count={history.length}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[5, 10, 25]}
                    />
                </TableContainer>
            </DialogContent>

            {/* Bouton Fermer */}
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    Fermer
                </Button>
            </DialogActions>
        </Dialog>
    );
}